import CreditCard from "./CreditCard";

class PaymentMethod {
  use_default = true;
  credit_card = new CreditCard();

  constructor(props) {
    Object.assign(this, props);

    this.credit_card = new CreditCard(this.credit_card);
  }
}

export default PaymentMethod;